export default {
  dp: {
    survey: {
      membershipRemoval: {
        title: 'Avant de partir...',
        close: 'Fermer le sondage',
      },
      designerTagRemoval: {
        title: 'Avant de partir...',
        close: 'Fermer le sondage',
      },
    },
    footer: {
      copyright: 'DocuPet Inc. Tous droits réservés.',
      tos: 'Conditions de service',
      privacy: 'Politique de confidentialité',
      cookieSettings: 'Paramètres des témoins',
    },
    navbar: {
      toggle: {
        close: 'Fermer',
        default: 'Menu',
      },
      tagStore: 'Magasin de balises',
      shop: 'Magasin',
      tagGallery: 'Galerie de tags',
      safeAndHappyFund: 'Safe&Happy Fund',
      licensing: 'Licence',
      homeSafe: 'Home<em>Safe</em><sup>&reg;</sup>',
      store: 'Magasin',
      about: 'À propos',
      licensingInfo: 'À propos des nouvelles licences',
      faq: 'FAQ',
      aboutRenewing: 'À propos du renouvellement des licences',
      signup: 'Inscrivez-vous',
      login: 'Connexion',
      dashboard: 'Mon tableau de bord',
      myDetails: 'Mes Details',
      myAccount: 'Mon Compte',
      logOut: 'Se déconnecter',
      yourAccount: 'Compte',
      myPets: 'Mes animaux de compagnie',
      profileSettings: 'Paramètres de profil',
      billingDetails: 'Paiements et abonnements',
      orderHistory: 'Historique des commandes',
      helpDesk: "Centre D'aide",
      logoDescription: 'DocuPet - Un foyer sûr et heureux pour chaque animal',
      skipToMainContent: 'Passer au contenu principal',
      basket: {
        ariaLabel: "Panier d'achats ({basketCount} articles)",
      },
      petGuardians: "Gardiens d'animaux de compagnie",
      shopDropdown: {
        shopAll: 'Magasiner Tout',
        tags: 'Médailles',
        smartTracker: 'Smart Tracker',
        walletCards: 'Cartes de portefeuille',
        collars: 'Colliers d’identification',
      },
      language: 'Langage',
      locales: {
        en_CA: 'English [CA]',
        en_US: 'English [US]',
        es_US: 'Español [US]',
        fr_CA: 'Français [CA]',
      },
      backToMenu: 'Retour au menu',
    },
    addAddress: {
      manualAddressHeader: "Ajoutez l'adresse",
      button: 'Add Address',
    },
    errorMessages: {
      poBoxOnly:
        "Nous avons besoin d'une adresse physique pour votre profil au cas où votre animal se perdrait et devrait vous être rendu. Vous pouvez ajouter une adresse postale supplémentaire en décochant la case ci-dessous.",
      invalidCharacters: 'Le {field} contient des caractères non valides',
    },
    input: {
      firstName: {
        label: 'Prénom',
        placeholder: 'Entrez votre prénom',
        customErrorMessage: {
          isEmpty: 'Your first name is required',
        },
      },
      lastName: {
        label: 'Nom de famille',
        placeholder: 'Entrer le nom de famille',
        customErrorMessage: {
          isEmpty: 'Your last name is required',
        },
      },
      email: {
        label: 'Adresse courriel',
        placeholder: 'Entrer adresse courriel',
        customErrorMessage: {
          isEmpty: 'Veuillez saisir votre adresse courriel',
          hasValue: 'Veuillez saisir une adresse courriel valide au format nom@exemple.com',
        },
        asyncErrorMessage: {
          emailAlreadyExists: `<strong>This email address already exists in our system.</strong><br/>If this is your account, please click <a class="text-decoration-underline" href="{loginLink}">here</a> to log in. Otherwise, please double check you're entering the correct email address.`,
          accountAlreadyExists: `<strong>This email address already exists in our system.</strong><br/>If you have previously registered a pet, we likely have your record on file. Visit the <a class="text-decoration-underline" href="{loginLink}">Fetch my record</a> page to continue.`,
        },
      },
      password: {
        label: 'Créer un mot de passe',
        placeholder: 'Créer un mot de passe',
        customErrorMessage: {
          isEmpty: 'Veuillez saisir un mot de passe',
          hasValue: 'Votre mot de passe ne respecte pas les exigences ci-dessous',
          mismatch: 'Les mots de passe ne correspondent pas',
        },
        show: 'Masquer le mot de passe',
        hide: 'Afficher le mot de passe',
      },
      agreeToTermsConditions: {
        label: "Je suis d'accord",
        customErrorMessage: 'Please read and agree to the Terms of Service to proceed',
      },
      agreeToMovingJurisdiction: {
        customErrorMessage: 'Please select this field to continue with moving the pet owner to a new jurisdiction',
      },
      addressSearch: {
        label: 'Search for your {selectedType}',
        placeholder: 'Start typing to search for {selectedType}',
        placeholderAddress: 'address',
        customErrorMessage: 'Please provide your address',
      },
      unit: {
        label: 'Unité / APT / SUITE',
        placeholder: '',
        customErrorMessage:
          'The unit / apt / suite field may only contain alpha-numeric characters, spaces and periods (e.g. Ste. 4, Apt. B).',
      },
      civic: {
        label: 'Nombre',
        placeholder: '',
        customErrorMessage: 'Please enter your address number',
      },
      street: {
        label: 'Rue',
        placeholder: 'Entrez le nom de la rue',
        customErrorMessage: 'Please enter your street name',
      },
      additional: {
        label: '',
        placeholder: 'Supplémentaire / Boîte postale',
      },
      city: {
        label: 'Ville',
        placeholder: 'Entrez le nom de la ville',
        customErrorMessage: 'Please enter your city name',
      },
      state: {
        label: 'State',
        placeholder: '',
        customErrorMessage: 'Please select your state',
      },
      province: {
        label: 'Province',
        placeholder: '',
        customErrorMessage: 'Please select your province',
      },
      postalCode: {
        label: 'Code postal',
        placeholder: 'Entrez le code postal',
        customErrorMessage: {
          required: 'Please enter your postal code',
          invalid: 'Please enter a Postal Code with 6 letters and numbers',
        },
      },
      zipCode: {
        label: 'Zip Code',
        placeholder: 'Enter zip code',
        customErrorMessage: {
          required: 'Please enter your ZIP code',
          invalid: 'Please enter a ZIP Code with 5 numbers.',
        },
      },
      phoneNumber: {
        label: 'Phone Number',
        placeholder: 'Enter {phoneNumberType} phone number',
        mobilePhone: 'Mobile',
        homePhone: 'Home',
        workPhone: 'Work',
        customErrorMessage: {
          hasValue: 'Please enter your ten digit phone number',
          isEmpty: 'Please enter your phone number',
        },
      },
      birthday: {
        customErrorMessage: {
          month: {
            isEmpty: 'Please select a month',
          },
          day: {
            hasValue: 'Please enter a number between 1 and 31',
            isEmpty: 'Please enter a day',
          },
          year: {
            hasValue: 'Please enter 4 numbers for the year',
            isEmpty: 'Please enter a year',
          },
        },
      },
      dates: {
        monthOptions: {
          default: 'Select',
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          may: 'May',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sept: 'Sept',
          oct: 'Oct',
          nov: 'Nov',
          dec: 'Dec',
        },
        errors: {
          birthdateMustBeInPast: 'Birthdates must be in the past',
          mustBeEighteen: 'You must be 18 years or older to purchase a license',
          mustBeEighteenOptional:
            'Fournir votre date de naissance est optionnel, toutefois, vous devez avoir au moins 18 ans pour obtenir une licence',
          rabiesVaccineExpirMustBeFuture: 'Rabies vaccination expiration dates must be in the future',
          twentyYears: "The rabies vaccination expiration date can't be more than 20 years in the future",
          between: 'Please enter a number between {minNum} and {maxNum}',
          minNumeric: 'Please enter at least {numLimit} numbers',
          maxNumeric: 'Please limit your input to {numLimit} numbers',
          min: 'Please enter at least {numLimit} characters',
          max: 'Please limit your input to {numLimit} characters',
        },
      },
      breed: {
        customErrorMessage: {
          breedAllowedChars:
            'Les races d’animaux ne peuvent contenir que des lettres, des espaces, des parenthèses, le signe « - » et le signe « + ».',
          required: "Veuillez indiquer la race de l'animal",
        },
      },
      breedKnown: {
        customErrorMessage: {
          required: 'Veuillez faire une sélection ci-dessus.',
        },
      },
    },
    petPanel: {
      aboutYourPet: 'Tell us about your pet',
      dontHaveAPet: "Don't have a pet?",
      skipThisStep: 'Skip this step',
      whatKindOfPet: 'What kind of pet do you have?',
      chooseOne: 'Choose one',
      petsName: "What is your pet's name?",
      petNameEditWarning:
        "Update your pet's name if the spelling is incorrect or if you are changing the name of your pet. Don't use this record for another pet as all of your pet's information needs to match the details that are on official documents that may need to be provided for licensing.",
      knowBreed: 'Connaissez-vous la race de votre animal ?',
      whatBreed: "De quelle race s'agit-il ?",
      breedInfoPanel:
        'Commencez à saisir la race de votre animal, puis sélectionnez celle qui correspond le mieux parmi les options proposées. Choisir la race la plus proche facilite l’identification de votre animal en cas de perte.',
      whatGender: 'What sex are they?',
      knowBirthDate: 'Do you know their date of birth?',
      approximateAge: 'Approximate Age',
      whatColor: 'What color are they? Select all that apply.',
      selectAll: 'Select all that apply',
      indoorCat: 'Indoor Cat',
      outdoorCat: 'Outdoor Cat',
      petCatOptionsRequired: 'Please let us know if {catName} is an indoor cat or an outdoor cat.',
      petSpeciesRequired: "Please select your pet's species",
      petNameRequired: "Please enter your pet's name",
      breedEditLink: 'corriger',
      petSexRequired: "Please select your pet's sex",
      petAgeRequired: "Please provide your pet's age",
      petApproximateBirthdateRequired: "Please approximate your pet's age",
      petColorRequired: 'Please pick at least one color',
      petWithNameExists: 'A pet with that name already exists',
      namePlaceholder: 'Enter a name',
      breedPlaceholder: 'Enter breed',
      noMorePets: 'No more pets to add?',
      birthdate: 'Birthdate',
    },
    ageOptions: {
      underSixMonths: 'Under 6 months',
      sixMonthsToOneYear: '6 months - 1 year',
      oneYear: '1 year',
      timesYears: '{yearNumber} years',
      seventeenPlusYears: '17+ years',
    },
    colors: {
      white: 'Blanc',
      lightGrey: 'Gris clair',
      darkGrey: 'Gris foncé',
      black: 'Noir',
      orange: 'Orange',
      red: 'Rouge',
      cream: 'Crème',
      apricot: 'Abricot',
      golden: 'Or',
      tan: 'Tan',
      brown: 'Brun',
      darkBrown: 'Marron foncé',
      lightSilver: 'Argent clair',
      silver: 'Argent',
      lilac: 'Lilas',
      blue: 'Bleu',
      darkBlue: 'Bleu foncé',
      yellow: 'Jaune',
      rust: 'Rouille',
      lightBrown: 'Marron clair',
      grey: 'Gris',
      beige: 'Beige',
      blonde: 'Blond',
      fawn: 'Fauve',
      liver: 'Foie',
      chocolate: 'Chocolat',
    },
    generic: {
      optional: 'Optionnel',
      yes: 'Yes',
      no: 'No',
      male: 'Male',
      female: 'Female',
      dog: 'Dog',
      cat: 'Cat',
      continue: 'Continue',
    },
    stripeForm: {
      cvcHeader: 'Guide de localisation du code CVV/CVC',
      cvcHelper:
        'Le code CVV/CVC (Card Verification Value/Code) se trouve au dos de votre carte de crédit/débit, à droite de la bande de signature blanche. Ce sont toujours les 3 derniers chiffres en cas de VISA et MasterCard. Veuillez copier votre code CVV/CVC au dos de votre carte et poursuivre votre paiement.',
      cvcHelperImageAlt:
        "Recherchez le code de sécurité à 3 chiffres au dos de votre carte et le code de sécurité à 4 chiffres à l'avant.",
      cardNumber: 'Numéro de carte',
      expiryDate: "Date d'expiration",
      cvcNumber: 'CVC',
      country: 'Country',
      postalCode: 'Code postal',
      postalCodePlaceholder: 'A1A 0A0',
    },
    jurisdictionChange: {
      pleaseSelectFromDropdown:
        "We couldn't automatically select the licensing jurisdiction for your updated address. Please select a jurisdiction from the list below.",
      deactivateAccount: 'Deactivate Account',
    },
    imageCropper: {
      title: 'Crop Your Photo',
      cancel: 'Cancel',
      back: 'Back',
      applyCrop: 'Apply Crop',
      addToCard: 'Add to Card',
      error: 'Something went wrong, please try again',
    },
    petTemperament: {
      counter: 'Select up to {counter} more from the list below',
      selection: '{selected} out of {max} selected! Deselect 1 option to choose another.',
    },
    rabiesProofUploader: {
      label: 'Please provide the rabies vaccination proof for {petName}',
      pronoun: 'When does {pronoun}',
      expire: 'rabies vaccination expire?',
      subLabel: '@:dp.rabiesProofUploader.pronoun @:dp.rabiesProofUploader.expire',
      subLabelNew: '@:dp.rabiesProofUploader.pronoun new @:dp.rabiesProofUploader.expire',
      helpText: 'Please upload a JPG, BMP, PNG, TIF, HEIC, WEBP or PDF file that is smaller than 8MB.',
      notRequired: 'No proof required',
    },
    buttons: {
      remove: 'Remove',
      loading: 'Loading...',
      uploadProof: 'Upload Proof',
      learnMoreLinkText: 'ici',
    },
    productNotFound: {
      backToStore: 'Back to Store',
      notFound: 'Ooops... product not found!',
      error: 'Ooops... something went wrong!',
      buttons: {
        viewAll: 'View All Products',
        refresh: 'Click to Refresh',
      },
    },
    requestAccessCode: {
      errorMessages: {
        access_code_used: "Looks like you've already signed up! {action}",
        default: 'There was a problem with your complete sign-up.{br}Please try again.',
        action: {
          access_code_used: 'Click here to Log In',
        },
      },
    },
    imageConversion: {
      errors: {
        default: 'Something went wrong, please try again',
        invalidType: 'Please upload a JPG, BMP, PNG, TIF, HEIC or WEBP file',
        tooLarge: 'Please upload a file smaller than 10MB',
        inconvertible: 'Something went wrong, please try different image',
      },
    },
    suggestedJurisdictions: {
      title: 'Dites-nous dans quelle communauté vous vivez',
      fallbackJurisdictionOptionLabel: 'Aucune des réponses ci-dessus',
    },
    securePasswordCheckList: {
      isSecure: 'Votre mot de passe est sécurisé!',
      oneLowerChar: 'Une lettre minuscule (ex. « j », « p », « a »)',
      oneUpperChar: 'Une lettre majuscule (ex. « J », « P », « A »)',
      oneDigitChar: 'Un chiffre (ex. « 1 », « 5 », « 8 »)',
      oneSpecialChar: 'Un caractère spécial (ex. « & », « # », « $ »)',
      min: '12 caractères minimum',
    },
    error: {
      title: 'Esprits!',
      body: "On dirait que quelque chose s'est mal passé ! Si vous continuez à recevoir ce message, veuillez nous le faire savoir.",
    },
    required: 'Obligatoire',
  },
};
